import { render } from "./FrozenBanner.vue?vue&type=template&id=9a404410&ts=true"
import script from "./FrozenBanner.vue?vue&type=script&lang=ts"
export * from "./FrozenBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__